import { Tooltip } from "@mui/material";

import styles from "./style.module.scss";

interface ILightPlusBtn {
    type: "plus" | "minus";
    onClick: () => void;
    tooltipTitle?: string;
    /** danger enlarges a minus button so removal is the obvious action. */
    variant?: "default" | "danger" | "black";
}

const LightPlusBtn = ({ tooltipTitle = undefined, onClick, type = "plus", variant = "default" }: ILightPlusBtn) => {
    const className = [
        styles["light-plus-btn"],
        variant === "danger" ? styles["light-plus-btn--danger"] : "",
        variant === "black" ? styles["light-plus-btn--black"] : "",
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <Tooltip title={tooltipTitle} arrow placement="right">
            <div className={className} onClick={onClick}>
                {type === "plus" ? "+" : "-"}
            </div>
        </Tooltip>
    );
};

export default LightPlusBtn;
